import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";


@Component({
	templateUrl: './mtma-confirm-import.dialog.component.html',
	styles: `
	`
})

export class MtmaConfirmImportDialogComponent {
	row1: string = '';
	row2: string = '';

	icon: string = 'cm-info';

	acceptButtonLabel: string = 'SAVE';
	acceptButtonStyle: string = 'p-button-info';

	rejectButtonLabel: string = 'CLOSE';
	rejectButtonStyle: string = 'p-button-secondary';

	constructor(
		private refDialog: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		if (config.data) {
			if (config.data.row1) {
				this.row1 = config.data.row1;
			}
			if (config.data.row2) {
				this.row2 = config.data.row2;
			}
			if (config.data.icon) {
				this.icon = config.data.icon;
			}
			if (config.data.acceptButtonLabel) {
				this.acceptButtonLabel = config.data.acceptButtonLabel;
			}
			if (config.data.acceptButtonStyle) {
				this.acceptButtonStyle = config.data.acceptButtonStyle;
			}
			if (config.data.rejectButtonLabel) {
				this.rejectButtonLabel = config.data.rejectButtonLabel;
			}
			if (config.data.rejectButtonStyle) {
				this.rejectButtonStyle = config.data.rejectButtonStyle;
			}
		}
	}

	accept(): void {
		//close(accepted: boolean)
		this.refDialog.close(true);
	}

	reject(): void {
		//close(accepted: boolean)
		this.refDialog.close(false);
	}

}